<div class="card-table">
  <div class="header-wrapper">
    <div class="inline">
      @if (config.headerTitle) {
        <div>
          {{ config.headerTitle | translate }}
        </div>
        @if (config.headerTitleTooltip) {
          <app-tooltip [text]="config.headerTitleTooltip" [marginBottom]="false" />
        }
      }
    </div>
    <div class="actions">
      @for (action of config.headerActions; track $index) {
        @if (action.type === 'button') {
          <button class="secondary" (click)="action.onClick()">
            {{ action.title | translate }}
          </button>
        } @else {
          <a [href]="action.href">{{ action.title | translate }}</a>
        }
      }
    </div>
  </div>

  <div class="content">
    <table class="table my-0">
      <thead>
        <tr>
          @for (column of config.columns; track $index) {
            <th>
              <p>{{ column.title | translate }}</p>
              @if (column.tooltip) {
                <div class="tooltip-wrapper">
                  <app-tooltip [marginBottom]="false" [text]="column.tooltip" />
                </div>
              }
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (item of config.data(); track $index) {
          <tr>
            @for (column of config.columns; track $index) {
              <td class="table-cell">
                @if (column.propertyName) {
                  <p>
                    {{ getPropertyValueAsString(item, column.propertyName) | translate }}
                  </p>
                } @else if (column.customLogic) {
                  @if (column.customLogic === 'ValueCompare') {
                    <app-reading-room-submission-initial-values-modal [entry]="item" />
                  } @else if (column.customLogic === 'IrChangeResult') {
                    <app-ir-process-history-result [entry]="item" />
                  }
                } @else if (column.convert!) {
                  <p>
                    {{ column.convert(item) | translate }}
                  </p>
                } @else {
                  <p [innerHTML]="column.getter!(item)"></p>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (config.footerActions?.length) {
    <div class="header-wrapper">
      <div class="inline"></div>
      <div class="actions">
        @for (action of config.footerActions; track $index) {
          @if (action.type === 'button') {
            <button class="secondary" (click)="action.onClick()">
              {{ action.title | translate }}
            </button>
          } @else {
            <a [href]="action.href">{{ action.title | translate }}</a>
          }
        }
      </div>
    </div>
  }
</div>
